import { parameterize } from "@uenf/layout";

const routes = {
  descricaoMateriais: params => `${RELATIVE_URL_PATH}/materiais/descricao?${parameterize(params)}`,
}

export { routes };
